<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <div :class="$style.sidebar">
        <div :class="$style.tabsWrapper">
          <v-popover :open.sync="isMenuActive" placement="bottom-start" popoverClass="no-arrow">
            <div :class="['tooltip-target', $style.menuButtonIcon]">
              <BaseIcon custom name="ellipsisY" />
            </div>
            <MainMenu :class="$style.menu" slot="popover" v-close-popover />
          </v-popover>
          <FilterSelect />
          <!--          <div :class="$style.tabs">-->
          <!--            <ul>-->
          <!--              <li v-for="(tab, index) in tabs" :key="index">-->
          <!--                <a href="#" @click.prevent="onTabClick(tab)" :class="{ [$style.activeTab]: currentTab === tab.value }">-->
          <!--                  <p>-->
          <!--                    <span v-show="tab.hasBadge">-->
          <!--                      {{ tab.countBadge }}-->
          <!--                    </span>-->
          <!--                    {{ tab.title }}-->
          <!--                  </p>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
        </div>
        <router-link :to="{ name: 'callouts' }">
          <CalloutsButton />
        </router-link>
        <router-view name="sidebar" ref="sidebar" />
      </div>
      <div :class="$style.view">
        <router-view name="infoHeader" @search-in-chat="searchInChat" :class="$style.infoHeader" />
        <template v-if="isPreparedMatrix && !isFirstSync"></template>
        <router-view />
      </div>
    </div>

    <!-- POPUPS -->
    <Contacts @go-to-chat="chat => setActiveChat(chat.id)" />
    <Settings />
    <NewChat @go-to-chat="chat => setActiveChat(chat.id)" />
    <GroupProfile />
    <GroupProfileMatrix />
    <ForwardTo />
    <AddUsersToChat />
    <DeleteChat />
    <DeleteChatMatrix />
    <EditGroup />
    <EditGroupMatrix />
    <CreateBlog />
    <EditBlog />
    <DeleteBlog />
    <DeleteBlogPost />
    <BlogProfile />
    <ShareToChat />
    <CalloutProfile />
    <DeleteSocialPost />
    <SocialProfileSubscriptions />
    <SocialSearch />
    <AddFilter />

    <Profile @go-to-chat="chat => setActiveChat(chat.id)" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
// import Hamburger from '@/components/Hamburger'
import MainMenu from '@/views/Messenger/MainMenu'
import CalloutsButton from '@/views/Messenger/callouts/CalloutsButton'

// modals
import Contacts from '@/components/modals/Contacts'
import Settings from '@/components/modals/Settings'
import Profile from '@/components/modals/Profile'
import GroupProfile from '@/components/modals/GroupProfile'
import GroupProfileMatrix from '@/components/modals/GroupProfileMatrix'
import ForwardTo from '@/components/modals/ForwardTo'
import NewChat from '@/components/modals/NewChat'
import AddUsersToChat from '@/components/modals/AddUsersToChat'
import DeleteChat from '@/components/modals/DeleteChat'
import DeleteChatMatrix from '@/components/modals/DeleteChatMatrix'
import EditGroup from '@/components/modals/EditGroup'
import EditGroupMatrix from '@/components/modals/EditGroupMatrix'
import CreateBlog from '@/components/modals/CreateBlog'
import EditBlog from '@/components/modals/EditBlog'
import BlogProfile from '@/components/modals/BlogProfile'
import DeleteBlog from '@/components/modals/DeleteBlog'
import DeleteBlogPost from '@/components/modals/DeleteBlogPost'
import ShareToChat from '@/components/modals/ShareToChat'
import CalloutProfile from '@/components/modals/CalloutProfile'
import DeleteSocialPost from '@/components/modals/DeleteSocialPost'
import SocialProfileSubscriptions from '@/components/modals/SocialProfileSubscriptions'
import SocialSearch from '@/components/modals/SocialSearch'
import FilterSelect from '@/components/FIlterSelect'
import AddFilter from '@/components/modals/AddFilter'
// modals
import { findLast } from 'lodash'

import initFirebase from '@/firebase'
import { formattedRoomItem } from '@/helpers'

import * as matrixSDK from 'matrix-js-sdk'
import { eventTypes, msgTypes, messengerProviders, selfMembershipTypes, chatNamesForBridge } from '@/helpers/variables'
import { parseRouterQueryParam } from '@/helpers/index'
const generatorPassword = require('generate-password')

export default {
  name: 'messenger',
  components: {
    // Hamburger,
    AddFilter,
    Contacts,
    FilterSelect,
    Settings,
    Profile,
    GroupProfile,
    GroupProfileMatrix,
    MainMenu,
    ForwardTo,
    NewChat,
    AddUsersToChat,
    DeleteChat,
    DeleteChatMatrix,
    EditGroup,
    EditGroupMatrix,
    CreateBlog,
    EditBlog,
    BlogProfile,
    DeleteBlog,
    DeleteBlogPost,
    ShareToChat,
    CalloutsButton,
    CalloutProfile,
    DeleteSocialPost,
    SocialProfileSubscriptions,
    SocialSearch
  },
  data () {
    return {
      isMenuActive: false,
      isFirstSync: true,
      isPreparedMatrix: false
    }
  },
  computed: {
    ...mapState({
      isBridgeWhatsapp: state => state.matrix.matrixCredentials && state.matrix.matrixCredentials.isBridgeWhatsapp
    }),
    ...mapGetters({
      activeBlog: 'entities/blogs/activeBlog',
      activeChat: 'entities/chats/activeChat',
      isLoadingMatrix: 'matrix/isLoading',
      matrixCredentials: 'matrix/matrixCredentials',
      currentRoomMessages: 'matrix/currentRoomMessages',
      rooms: 'matrix/rooms',
      user: 'auth/user',
      isInitSocket: 'entities/chats/isInited',
      inviteMatrixRooms: 'matrix/inviteRooms'
    }),
    tabs () {
      return [
        {
          title: this.$t('tabAllChats'),
          value: 'chats',
          show: true
        },
        {
          title: this.$t('tabInvites'),
          value: 'invites',
          show: !!this.availableInvitesMatrixRooms.length,
          hasBadge: true,
          countBadge: this.availableInvitesMatrixRooms.length
        }
      ].filter(e => e.show)
    },
    currentTab () {
      return this.$route.query.tab || 'chats'
    },
    isMatrixView () {
      return this.$route.name === 'app-chat-matrix'
    },
    renderMatrixRouterView () {
      return this.isMatrixView ? this.rooms.length : false
    },
    activeChatId () {
      return parseRouterQueryParam(this.$route.query.id, true)
    },
    availableInvitesMatrixRooms () {
      if (!this.matrixCredentials) return []
      return this.inviteMatrixRooms.filter(
        e =>
          (e.subProvider && e.subProvider === messengerProviders.whatsapp && this.matrixCredentials.isBridgeWhatsapp) ||
          (e.subProvider && e.subProvider === messengerProviders.telegram && this.matrixCredentials.isBridgeTelegram)
      )
    }
  },
  async mounted () {
    this.setIsReadyMatrix(false)
    initFirebase()
    this.fetchFilters()
    this.fetchContacts()
    this.fetchCallouts()
    if (!window.matrixSDK) {
      await this.initMatrixSDK()
      this.checkAvailableMatrixCredentials()
    } else {
      this.checkAvailableMatrixCredentials()
    }
  },
  beforeDestroy () {
    this.offEvents()
  },
  methods: {
    ...mapActions({
      getChatMessages: 'entities/messages/fetch',
      fetchFilters: 'filter/fetchFilters',
      getMatrixCredentials: 'matrix/getMatrixCredentials',
      saveMatrixCredentials: 'matrix/saveMatrixCredentials',
      fetchContacts: 'entities/users/fetchContacts',
      getBlogCategories: 'entities/blogCategories/fetch',
      getPostCategories: 'entities/postCategories/fetch',
      fetchCallouts: 'entities/callouts/fetch',
      updateMatrixCredentials: 'matrix/updateMatrixCredentials'
    }),
    ...mapMutations({
      setMatrixRooms: 'matrix/SET_ROOMS',
      setMatrixInviteRooms: 'matrix/SET_INVITE_ROOMS',
      setTypingInRoom: 'matrix/SET_ROOM_TYPING_USER',
      addLastMessagesToChat: 'matrix/ADD_LAST_MESSAGES_TO_CHAT',
      addInviteRoom: 'matrix/ADD_INVITE_ROOM_TO_LIST',
      addNewMessagesToChat: 'matrix/ADD_NEW_MESSAGE_TO_CURRENT_ROOM',
      removeMessagesFromChat: 'matrix/REMOVE_MESSAGE_IN_CURRENT_ROOM',
      replaceMessagesInChat: 'matrix/REPLACE_MESSAGE_IN_CURRENT_ROOM',
      setIsReadyMatrix: 'matrix/SET_IS_READY_MATRIX',
      replaceRoom: 'matrix/REPLACE_ROOM'
    }),
    onTabClick (tab) {
      this.$router.replace({ name: 'app-chat', query: { ...this.$route.query, tab: tab.value } }).catch(e => {})
    },
    setActiveChat (chatId) {
      this.$router.push({ name: 'app-chat', params: { activeChatId: window.btoa(chatId) } })
    },
    searchInChat () {
      if (!this.$refs.sidebar) return
      this.$refs.sidebar.searchInChat()
    },
    async registerUserInMatrix () {
      const { nickname } = this.user
      const matrixUsername = nickname.replaceAll(':', '_').toLowerCase()
      const password = generatorPassword.generate({
        length: 10,
        numbers: true
      })
      await window.matrixSDK
        .registerRequest({
          auth: {
            type: 'm.login.dummy'
          },
          inhibit_login: false,
          initial_device_display_name: 'app.element.io (Chrome, macOS)',
          password: password,
          type: 'm.login.dummy',
          username: matrixUsername
        })
        .then(async () => {
          const credentials = { password, username: matrixUsername }
          await this.saveMatrixCredentials(credentials)
          await this.loginInMatrix(credentials)
        })
    },
    async loginInMatrix (credentials) {
      const { username, password } = credentials || this.matrixCredentials
      const loginResponse = await window.matrixSDK.login('m.login.password', { user: username, password })
      const loginClient = await matrixSDK.createClient({
        baseUrl: process.env.VUE_APP_MATRIX_URL,
        accessToken: loginResponse.access_token,
        userId: loginResponse.user_id
      })

      window.matrixSDK = loginClient

      await window.matrixSDK.startClient()
    },
    initMatrixSDK () {
      if (!window.matrixSDK) {
        let sdk = null
        const matrixUrl = process.env.VUE_APP_MATRIX_URL
        sdk = matrixSDK.createClient({ baseUrl: matrixUrl })

        window.matrixSDK = sdk
      }
    },
    async checkAvailableMatrixCredentials () {
      await this.getMatrixCredentials()
      if (!this.matrixCredentials.username) {
        await this.registerUserInMatrix()
      } else {
        await this.loginInMatrix()
      }

      await this.getMatrixRooms()
      this.isPreparedMatrix = true
      this.listenMemberTyping()
    },
    handlerRoomTyping (event, member) {
      const { roomId, name, userId } = member
      if (userId !== window.matrixSDK.credentials.userId) {
        if (member.typing) {
          this.setTypingInRoom({
            actionType: 'add',
            user: name,
            roomId: roomId
          })
        } else {
          this.setTypingInRoom({
            actionType: 'remove',
            user: name,
            roomId: roomId
          })
        }
      }
    },
    listenMemberTyping () {
      window.matrixSDK.on('RoomMember.typing', this.handlerRoomTyping)
    },
    handlerRoom (room) {
      const formattedRoom = formattedRoomItem(room, selfMembershipTypes.invite)
      this.addInviteRoom(formattedRoom)
    },
    listenRoom () {
      window.matrixSDK.on('Room', this.handlerRoom)
    },
    async handlerTimeline (event, room, toStartOfTimeline) {
      if (event.isRedaction()) {
        await this.setReadMarkers(event)
        this.removeMessagesFromChat(event.event)
        this.addLastMessagesToChat({
          roomId: room.roomId,
          event: event.event
        })
        return
      }
      if (toStartOfTimeline) {
        return // don't print paginated results
      }
      if (
        event.getType() !== eventTypes.message &&
        event.getType() !== eventTypes.member &&
        event.getType() !== eventTypes.avatar &&
        event.getType() !== eventTypes.name
      ) {
        return // only print messages
      }
      if (room.roomId === this.activeChatId) {
        await this.setReadMarkers(event)
        if (event.event.content.hasOwnProperty('m.new_content')) {
          this.replaceMessagesInChat(event.event)
        } else {
          if (this.currentRoomMessages.length) {
            this.addNewMessagesToChat(event.event)
          }
        }
        const currentRoom = window.matrixSDK.getRoom(this.activeChatId)
        const formattedRoom = formattedRoomItem(currentRoom)
        if (formattedRoom) this.replaceRoom(formattedRoom)
      } else {
        const formattedRoom = formattedRoomItem(room)
        this.replaceRoom(formattedRoom)
      }

      this.addLastMessagesToChat({
        roomId: room.roomId,
        event: event.event
      })
    },
    listenTimeline () {
      window.matrixSDK.on('Room.timeline', this.handlerTimeline)
    },
    offEvents () {
      window.matrixSDK.off('Room', this.handlerRoom)
      window.matrixSDK.off('Room.timeline', this.handlerTimeline)
      window.matrixSDK.off('RoomMember.typing', this.handlerRoomTyping)
    },
    async setReadMarkers (event) {
      const { userId } = window.matrixSDK.credentials
      const readableMessage = event.event.type === eventTypes.message && event.event.sender !== userId
      if (readableMessage) {
        await window.matrixSDK.setRoomReadMarkers(this.activeChatId, event.event.event_id, event, event)
      }
    },
    async checkWAReconnection () {
      const waReconnectMessage = 'The bridge was started in another location. Use'
      const reconnectMessage = 'reconnect'
      if (!this.isBridgeWhatsapp) return

      const rooms = window.matrixSDK.getRooms()
      const room =
        rooms.find(e => e.name === chatNamesForBridge.whatsapp && e.selfMembership === selfMembershipTypes.join) || {}
      const roomTimeline = room.timeline
      const message = findLast(roomTimeline, item => {
        const message = item.event.content.body || ''
        return message.includes(reconnectMessage)
      })
      if (message?.event.content.body.includes(waReconnectMessage)) {
        const content = {
          body: reconnectMessage,
          msgtype: msgTypes.text
        }
        const { roomId } = room
        window.matrixSDK.sendEvent(roomId, eventTypes.message, content, '')
      }
    },
    async checkWAAutoLogout () {
      const waAutoLogoutMessage = 'You were logged out from another device.'
      const waAutoLogoutMessage1 = 'Your phone was logged out from WhatsApp'
      const waAutoLogoutMessage2 = 'You were logged out for an unknown reason'
      if (!this.isBridgeWhatsapp) return

      const rooms = window.matrixSDK.getRooms()
      const room =
        rooms.find(e => e.name === chatNamesForBridge.whatsapp && e.selfMembership === selfMembershipTypes.join) || {}
      const roomTimeline = room.timeline
      const message = findLast(roomTimeline, item => {
        const msg = item.event.content.body || ''
        return (
          msg.includes(waAutoLogoutMessage) || msg.includes(waAutoLogoutMessage1) || msg.includes(waAutoLogoutMessage2)
        )
      })
      const contentLastMessage = message.event.content.body
      if (
        contentLastMessage.includes(waAutoLogoutMessage) ||
        contentLastMessage.includes(waAutoLogoutMessage1) ||
        contentLastMessage.includes(waAutoLogoutMessage2)
      ) {
        await this.handleDisconnectWA()
        const content = {
          body: 'logout',
          msgtype: msgTypes.text
        }
        const { roomId } = room
        window.matrixSDK.sendEvent(roomId, eventTypes.message, content, '')
      }
    },
    async handleDisconnectWA () {
      const payload = {
        is_bridge_whatsapp: false,
        whatsapp_phone: ''
      }
      await this.updateMatrixCredentials(payload)
      await this.getMatrixCredentials()
    },
    async getMatrixRooms () {
      await window.matrixSDK.once('sync', () => {
        if (this.isFirstSync) {
          this.checkWAReconnection()
          this.checkWAAutoLogout()
          this.setIsReadyMatrix(true)
          this.isFirstSync = false
          const rooms = window.matrixSDK.getRooms()

          const inviteRooms = rooms.filter(t => t.selfMembership === selfMembershipTypes.invite)
          const joinRooms = rooms.filter(t => t.selfMembership === selfMembershipTypes.join)
          const leaveRooms = rooms.filter(t => t.selfMembership === selfMembershipTypes.leave)

          const transformedRooms = joinRooms.map(e => formattedRoomItem(e))
          const transformedLeaveRooms = leaveRooms.map(e => formattedRoomItem(e))
          const transformedInviteRooms = inviteRooms.map(e => formattedRoomItem(e, selfMembershipTypes.invite))

          if (this.$refs.matrixView) {
            this.$refs.matrixView.onChatChange()
          }
          this.listenTimeline()
          this.listenRoom()
          this.setMatrixRooms([...transformedRooms, ...transformedLeaveRooms])
          this.setMatrixInviteRooms(transformedInviteRooms)
        }
      })
    }
  }
}
</script>

<style lang="scss" module>
$sidebar-width: 312px;
// $header-height: 48px;

.activeTab {
  border-bottom: 2px solid #00b764 !important;
}
.tabs {
  width: 100%;
  ul {
    height: 100%;
    display: flex;
    justify-content: center;
  }
  li {
    height: 100%;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  p {
    position: relative;
  }
  a {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    align-items: center;
    border-bottom: 2px solid $main-bg-dark;
    &:hover {
      background-color: $main-bg-dark;
    }
    span {
      position: absolute;
      top: -7px;
      right: -15px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: $text-error;
      font-size: 9px;
      color: #fff;
    }
  }
}

.wrapper {
  max-width: 1020px;
  // height: 100vh;
  height: calc(100vh - #{$header-height});
  margin: 0 auto;
  background-color: $main-bg-light;
}
.container {
  display: flex;
  color: $text-darkest;
  // height: calc(100vh - #{$header-height});
  height: 100%;
}
// .header {
//   height: $header-height;
//   background-color: $main-bg-colored;
//   color: $text-lightest;
//   display: flex;
//   align-items: stretch;
//   position: relative;
//   &::before {
//     content: '';
//     background-color: $main-bg-colored;
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: $header-height;
//     z-index: -1;
//   }
// }
.tabsWrapper {
  display: flex;
  flex-shrink: 0;
}
// .tabs {
//   flex-shrink: 0;
// }
.sidebar {
  border-right: 1px solid $border-color;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
// .headerMenu,
.sidebar {
  // flex-basis: 0;
  // flex-grow: 1;
  width: $sidebar-width;
  flex-shrink: 0;
}
// .headerMenu {
//   position: relative;
//   cursor: pointer;
// }
// .headerMenuTrigger {
//   display: flex;
//   align-items: center;
//   padding-left: 16px;
//   width: $sidebar-width;
//   height: $header-height;
// }
.menu {
  width: $sidebar-width;
}
.menuButtonIcon {
  font-size: 20px;
  height: 48px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: $text-mid-dark;
  &:hover {
    color: $text-colored;
  }
}

// .headerTitle {
//   font-size: 20px;
//   margin-left: 20px;
// }

.infoHeader {
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $border-color;
  height: 48px;
  flex-shrink: 0;
}
.view {
  flex-basis: 0;
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  min-width: 0;
}
</style>
